/**
 * @fileoverview GET handler for the "/engagement/sparse_segments_data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementSparseSegmentsData } from "./constants";
import type { EngagementSparseSegmentsDataResult } from "./types";

export const getEngagementSparseSegmentsData = reactQueryFetcherAdapter(
  engagementSparseSegmentsData,
  (signal: AbortSignal, appGroupId: string, showArchived: boolean): Promise<EngagementSparseSegmentsDataResult> => {
    return fetch(
      "/engagement/sparse_segments_data",
      "GET",
      { app_group_id: appGroupId, show_archived: showArchived },
      { signal }
    );
  }
);
